/* Dillo in Dialetto — landing regalo: scelta variante nelle card, kit poster + cornice, bottone fisso mobile */
import { CartLinesUpdateEvent } from '@shopify/events';

const root = () => window.Shopify?.routes?.root || '/';
const money = (cents) =>
  new Intl.NumberFormat('it-IT', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);

/* ---------- Card: la variante scelta diventa quella aggiunta dal bottone ---------- */
document.addEventListener('change', (e) => {
  const select = /** @type {HTMLElement} */ (e.target).closest('[data-did-gift-variant]');
  if (!select) return;
  const card = select.closest('[data-did-gift-card]');
  const option = /** @type {HTMLSelectElement} */ (select).selectedOptions[0];
  card?.querySelector('[data-did-add]')?.setAttribute('data-did-add', option.value);
  const price = card?.querySelector('[data-did-gift-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});

/* ---------- Kit poster + cornice ---------- */
function kitState(kit) {
  const data = JSON.parse(kit.querySelector('[data-did-kit-data]')?.textContent || '{}');
  const poster = data.posters[Number(kit.querySelector('[data-did-kit-poster]:checked')?.value || 0)];
  const frameColor = kit.querySelector('[data-did-kit-frame]:checked')?.value;
  return { data, poster, frameColor };
}

function chip(name, value, label, checked, attr) {
  const el = document.createElement('label');
  el.className = 'did-gift-chip';
  const input = document.createElement('input');
  input.type = 'radio';
  input.name = name;
  input.value = value;
  input.checked = checked;
  input.setAttribute(attr, '');
  const span = document.createElement('span');
  span.textContent = label;
  el.append(input, span);
  return el;
}

function renderKit(kit, keep = {}) {
  const { data, poster, frameColor } = kitState(kit);
  if (!poster) return;
  const available = poster.variants.filter((v) => v.available);
  const sizes = [...new Set(available.map((v) => v.size))];
  const size = sizes.includes(keep.size) ? keep.size : sizes.includes(data.defaultSize) ? data.defaultSize : sizes[0];
  const styles = [...new Set(available.filter((v) => v.size === size).map((v) => v.style).filter(Boolean))];
  const style = styles.includes(keep.style) ? keep.style : styles[0];

  const sizesEl = kit.querySelector('[data-did-kit-sizes]');
  sizesEl.replaceChildren(
    ...sizes.map((s) => chip(`kit-size-${kit.dataset.kitId}`, s, data.sizeMap[s.toUpperCase()] || s, s === size, 'data-did-kit-size'))
  );
  const stylesEl = kit.querySelector('[data-did-kit-styles]');
  stylesEl.replaceChildren(
    ...styles.map((s) => chip(`kit-style-${kit.dataset.kitId}`, s, s, s === style, 'data-did-kit-style'))
  );
  kit.querySelector('[data-did-kit-styles-field]').hidden = styles.length < 2;

  const posterVariant = available.find((v) => v.size === size && (!style || v.style === style));
  const frameSize = data.sizeMap[String(size).toUpperCase().replace(/\s/g, '')];
  const frameVariant =
    data.frames.find((f) => f.size.toUpperCase() === String(frameSize).toUpperCase() && f.color === frameColor && f.available) ||
    data.frames.find((f) => f.size.toUpperCase() === String(frameSize).toUpperCase() && f.available);

  const add = kit.querySelector('[data-did-kit-add]');
  const ok = Boolean(posterVariant && frameVariant);
  add.disabled = !ok;
  add.dataset.ids = ok ? `${posterVariant.id},${frameVariant.id}` : '';
  const total = ok ? posterVariant.price + frameVariant.price : 0;
  kit.querySelector('[data-did-kit-price]').textContent = ok ? money(total) : 'non disponibile';
  const threshold = Number(kit.dataset.threshold) || 4000;
  kit.querySelector('[data-did-kit-note]').textContent = !ok
    ? ''
    : total >= threshold
      ? 'Con questo kit la spedizione è gratuita.'
      : `Ti mancano ${money(threshold - total)} per la spedizione gratuita.`;
  const img = kit.querySelector('[data-did-kit-image]');
  const src = posterVariant?.image || poster.image;
  if (img && src && img.getAttribute('src') !== src) img.setAttribute('src', src);
}

function currentKeep(kit) {
  return {
    size: kit.querySelector('[data-did-kit-size]:checked')?.value,
    style: kit.querySelector('[data-did-kit-style]:checked')?.value,
  };
}

document.addEventListener('change', (e) => {
  const kit = /** @type {HTMLElement} */ (e.target).closest('[data-did-kit]');
  if (kit) renderKit(kit, currentKeep(kit));
});

/* ---------- Set regalo: totale, ids e cornice abbinata al formato del poster ---------- */
const FRAME_SIZE = { A4: 'A4', A3: 'A3', '48X68': '50x70', '50X70': '50x70' };

function syncSet(set, changed) {
  const items = [...set.querySelectorAll('[data-did-set-item]')];
  const posterSelect = items.find((i) => i.dataset.kind === 'poster')?.querySelector('select');
  const frameSelect = items.find((i) => i.dataset.kind === 'frame')?.querySelector('select');
  if (posterSelect && frameSelect && changed !== frameSelect) {
    const size = FRAME_SIZE[String(posterSelect.selectedOptions[0]?.dataset.size || '').toUpperCase().replace(/\s/g, '')];
    const color = frameSelect.selectedOptions[0]?.dataset.opt2;
    const options = [...frameSelect.options].filter((o) => o.dataset.size.toUpperCase() === String(size).toUpperCase());
    const match = options.find((o) => o.dataset.opt2 === color) || options[0];
    if (match) frameSelect.value = match.value;
  }
  let total = 0;
  const ids = [];
  let ok = true;
  items.forEach((item) => {
    const option = item.querySelector('select')?.selectedOptions[0];
    const id = option ? option.value : item.dataset.variant;
    const price = Number(option ? option.dataset.price : item.dataset.price);
    if (!id || item.hasAttribute('data-unavailable')) ok = false;
    ids.push(id);
    total += price;
  });
  const add = set.querySelector('[data-did-set-add]');
  add.disabled = !ok;
  add.dataset.ids = ok ? ids.join(',') : '';
  set.querySelector('[data-did-set-price]').textContent = ok ? money(total) : 'non disponibile';
  const threshold = Number(set.dataset.threshold) || 4000;
  const note = set.querySelector('[data-did-set-note]');
  note.classList.toggle('is-short', ok && total < threshold);
  note.textContent = !ok ? '' : total >= threshold ? '✓ Spedizione gratuita inclusa' : `Ti mancano ${money(threshold - total)} per la spedizione gratuita`;
  const extra = ok ? promoNote(items.length) : '';
  if (extra) note.textContent += ` · ${extra}`;
}

/* Promo stagionale attiva sulla pagina (data-did-promo sulla sezione): 3x2 o Natale -20% */
function promoNote(count) {
  const promo = document.querySelector('[data-did-promo]')?.getAttribute('data-did-promo');
  if (promo === 'n20') return '-20% in cassa';
  if (promo !== '3x2' || !count) return '';
  const missing = (3 - (count % 3)) % 3;
  if (missing === 0) return `3x2: ${count / 3 > 1 ? `${count / 3} prodotti` : 'il meno caro è'} in regalo`;
  return missing === 1 ? 'aggiungi 1 prodotto e il meno caro è in regalo' : `aggiungine ${missing} e il meno caro è in regalo`;
}

document.addEventListener('change', (e) => {
  const select = /** @type {HTMLElement} */ (e.target).closest('[data-did-set-variant]');
  if (select) syncSet(select.closest('[data-did-set]'), select);
});

async function addKit(button) {
  const ids = (button.dataset.ids || '').split(',').filter(Boolean);
  if (!ids.length || button.classList.contains('is-loading')) return false;
  const counts = new Map();
  ids.forEach((id) => counts.set(id, (counts.get(id) || 0) + 1));
  const lines = [...counts].map(([id, quantity]) => ({ id, quantity }));
  let success = false;
  button.classList.add('is-loading');
  button.setAttribute('aria-busy', 'true');

  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => /** @type {HTMLElement} */ (el).dataset.sectionId)
    .filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity })),
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(`${root()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines.map((l) => ({ id: Number(l.id), quantity: l.quantity })), sections: sectionIds.join(',') }),
    }).then((r) => r.json());
    const cart = await fetch(`${root()}cart.js`).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'did-gift-kit', itemCount: ids.length, sections: res.sections, didError: Boolean(res.status) },
    });
    success = !res.status;
    button.classList.add(res.status ? 'is-error' : 'is-added');
    if (!res.status) {
      const toggle = document.querySelector('[on\\:click="#cart-drawer/toggle"]');
      const drawerOpen = document.querySelector('dialog[open] .cart-drawer__inner');
      if (toggle && !drawerOpen) setTimeout(() => /** @type {HTMLElement} */ (toggle).click(), 350);
    }
    setTimeout(() => button.classList.remove('is-added', 'is-error'), 1800);
  } catch (error) {
    deferred.reject(error);
    button.classList.add('is-error');
  } finally {
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
  }
  return success;
}

/* ---------- Crea il tuo set: i prodotti scelti restano nel vassoio finché non si aggiunge tutto al carrello ---------- */
const builds = new WeakMap();
const buildItems = (build) => {
  if (!builds.has(build)) builds.set(build, []);
  return builds.get(build);
};

function renderBuild(build) {
  const items = buildItems(build);
  const tray = build.querySelector('[data-did-build-tray]');
  const list = build.querySelector('[data-did-build-items]');
  tray.hidden = items.length === 0;
  list.replaceChildren(
    ...items.map((item, i) => {
      const li = document.createElement('li');
      li.className = 'did-gift-build__item';
      const img = document.createElement('img');
      img.src = item.image;
      img.alt = [item.name, item.label].filter(Boolean).join(', ');
      img.width = 48;
      img.height = 48;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'did-gift-build__remove';
      remove.dataset.didBuildRemove = String(i);
      remove.setAttribute('aria-label', `Togli ${item.name} dal set`);
      remove.textContent = '×';
      li.append(img, remove);
      return li;
    })
  );
  const total = items.reduce((sum, item) => sum + item.price, 0);
  const threshold = Number(build.dataset.threshold) || 4000;
  const bar = build.querySelector('[data-did-build-bar]');
  const pct = Math.min(100, Math.round((total / threshold) * 100));
  bar.querySelector('span').style.width = `${pct}%`;
  bar.setAttribute('aria-valuenow', String(pct));
  bar.classList.toggle('is-done', total >= threshold);
  build.querySelector('[data-did-build-total]').textContent = money(total);
  const count = items.length === 1 ? '1 prodotto' : `${items.length} prodotti`;
  build.querySelector('[data-did-build-note]').textContent =
    (total >= threshold ? `${count} · ✓ Spedizione gratuita inclusa` : `${count} · Ti mancano ${money(threshold - total)} per la spedizione gratuita`) +
    (promoNote(items.length) ? ` · ${promoNote(items.length)}` : '');
  build.querySelector('[data-did-build-submit]').dataset.ids = items.map((item) => item.id).join(',');
  const chosen = new Set(items.map((item) => item.card));
  build.querySelectorAll('[data-did-build-card]').forEach((card) => card.classList.toggle('is-in-set', chosen.has(card)));
}

function filterBuild(build, category, showAll) {
  build.dataset.category = category;
  if (showAll) build.dataset.all = 'true';
  const all = build.dataset.all === 'true';
  let hiddenCount = 0;
  build.querySelectorAll('[data-did-build-card]').forEach((card) => {
    const match = !category || card.dataset.category === category;
    const hide = !match || (!category && !all && card.hasAttribute('data-extra'));
    card.hidden = hide;
    if (match && hide) hiddenCount += 1;
  });
  build.querySelector('[data-did-build-more]').hidden = hiddenCount === 0;
  build.querySelectorAll('[data-did-build-filter]').forEach((button) => {
    const active = button.dataset.didBuildFilter === category;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });
}

document.addEventListener('change', (e) => {
  const select = /** @type {HTMLElement} */ (e.target).closest('select[data-did-build-variant]');
  if (!select) return;
  const price = select.closest('[data-did-build-card]')?.querySelector('[data-did-build-price]');
  const option = /** @type {HTMLSelectElement} */ (select).selectedOptions[0];
  if (price) price.textContent = money(Number(option.dataset.price));
});

document.addEventListener('click', async (e) => {
  const target = /** @type {HTMLElement} */ (e.target);
  const build = target.closest('[data-did-build]');
  if (!build) return;

  const filter = target.closest('[data-did-build-filter]');
  if (filter) return filterBuild(build, filter.dataset.didBuildFilter || '');
  if (target.closest('[data-did-build-more]')) return filterBuild(build, build.dataset.category || '', true);

  const add = target.closest('[data-did-build-add]');
  if (add) {
    const card = add.closest('[data-did-build-card]');
    const field = card.querySelector('[data-did-build-variant]');
    const option = field.tagName === 'SELECT' ? field.selectedOptions[0] : field;
    buildItems(build).push({
      id: option.value,
      price: Number(option.dataset.price),
      label: field.tagName === 'SELECT' ? option.textContent.trim() : '',
      name: card.dataset.name,
      image: card.dataset.image,
      card,
    });
    return renderBuild(build);
  }

  const remove = target.closest('[data-did-build-remove]');
  if (remove) {
    buildItems(build).splice(Number(remove.dataset.didBuildRemove), 1);
    return renderBuild(build);
  }

  const submit = target.closest('[data-did-build-submit]');
  if (submit) {
    const ok = await addKit(submit);
    if (ok) {
      buildItems(build).length = 0;
      setTimeout(() => renderBuild(build), 1200);
    }
  }
});

document.addEventListener('click', (e) => {
  const button = /** @type {HTMLElement} */ (e.target).closest('[data-did-kit-add]');
  if (button) addKit(button);
});

/* ---------- Bottone fisso su mobile: compare dopo l'hero, sparisce quando i regali sono a schermo ---------- */
function setupSticky() {
  const sticky = document.querySelector('[data-did-gift-sticky]');
  const hero = document.querySelector('.did-gift-hero');
  const picks = document.getElementById('regali');
  if (!sticky || !hero || !picks || !('IntersectionObserver' in window)) return;
  const visible = new Map();
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => visible.set(entry.target, entry.isIntersecting));
    sticky.hidden = [...visible.values()].some(Boolean);
  });
  io.observe(hero);
  io.observe(picks);
  document.querySelectorAll('[data-did-build]').forEach((b) => io.observe(b));
}

function init() {
  document.querySelectorAll('[data-did-kit]').forEach((kit, i) => {
    kit.dataset.kitId = String(i);
    renderKit(kit);
  });
  document.querySelectorAll('[data-did-set]').forEach((set) => syncSet(set));
  document.querySelectorAll('[data-did-build]').forEach((build) => filterBuild(build, ''));
  setupSticky();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
